var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-survey__inner c-survey__bg--yellow" }, [
    _vm.settings.prizeDrawEnabled
      ? _c("div", { staticClass: "c-survey__bar c-survey__bg--blue" }, [
          _c("div", { staticClass: "c-survey__bar-inner" }, [
            _c("h1", { staticClass: "white-text" }, [
              _vm._v(
                _vm._s(_vm.thankyou.preCode) +
                  " " +
                  _vm._s(_vm.submissionData.prizeDrawCode)
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "c-survey__content c-survey__content--padding" }, [
      _c("div", { staticClass: "c-survey__grid c-survey__grid--page-three" }, [
        _c("div", { staticClass: "c-survey__thankyou-content-wrapper" }, [
          _c("main", {
            staticClass: "c-survey__html",
            domProps: { innerHTML: _vm._s(_vm.thankyou.content) },
          }),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.submissionData.email,
                  expression: "submissionData.email",
                },
              ],
              staticClass: "c-survey__email-input",
              attrs: {
                type: "text",
                placeholder: _vm.thankyou.emailInputPlaceholder,
              },
              domProps: { value: _vm.submissionData.email },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.submissionData, "email", $event.target.value)
                  },
                  _vm.handleEmailInput,
                ],
                focus: _vm.handleEmailFocus,
              },
            }),
            _vm._v(" "),
            _vm.emailTouched &&
            !_vm.isSubmitButtonActive &&
            _vm.submissionData.email !== ""
              ? _c("div", { staticClass: "c-survey__field-error" }, [
                  _vm._v("Please enter a valid email address to proceed"),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "c-survey__email-consent-wrapper" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.submissionData.consent,
                  expression: "submissionData.consent",
                },
              ],
              attrs: { type: "checkbox", required: true },
              domProps: {
                checked: Array.isArray(_vm.submissionData.consent)
                  ? _vm._i(_vm.submissionData.consent, null) > -1
                  : _vm.submissionData.consent,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.submissionData.consent,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.submissionData,
                          "consent",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.submissionData,
                          "consent",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.submissionData, "consent", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("main", {
              staticClass: "c-survey__html c-survey__html--small",
              domProps: { innerHTML: _vm._s(_vm.thankyou.consent) },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "c-survey__actionbutton-row c-survey__actionbutton-row",
            },
            [
              _c("ActionButton", {
                attrs: {
                  title: _vm.thankyou.submitLabel,
                  buttonAction: "submit",
                  disabled: !_vm.isSubmitButtonActive,
                },
              }),
              _vm._v(" "),
              _c("ActionButton", {
                attrs: {
                  title: _vm.thankyou.skipLabel,
                  buttonAction: "next",
                  muted: true,
                  requireConfirmation: true,
                  confirmationHeading: _vm.thankyou.confirmSkipHeading,
                  confirmationMessage: _vm.thankyou.confirmSkipContent,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("main", {
            staticClass: "c-survey__html c-survey__html--small",
            domProps: { innerHTML: _vm._s(_vm.thankyou.terms) },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm.settings.prizeDrawEnabled
              ? _c("lottie-vue-player", {
                  attrs: {
                    src: _vm.thankyou.animationFilePrizesEnabled,
                    "player-controls": false,
                    loop: true,
                    autoplay: true,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.settings.prizeDrawEnabled
              ? _c("lottie-vue-player", {
                  attrs: {
                    src: _vm.thankyou.animationFilePrizesDisabled,
                    "player-controls": false,
                    loop: true,
                    autoplay: true,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-survey__content-spacer" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }